import React, { useEffect, useState } from 'react';


const monthArr = ["Січень",
                "Лютий",
                "Березень",
                "Квітень",
                "Травень",
                "Червень",
                "Липень",
                "Серпень",
                "Вересень",
                "Жовтень",
                "Листопад",
                "Грудень"];



const setRange = (start, finish) => new Array( finish - start + 1).fill().map((_,i)=>start + i);
const toObjDate = (ISODate)=>{
    if(!ISODate || typeof ISODate !== "string") return ({ day: 1, month: 1, year: 2025}); 
    const [year,month,day] = ISODate.split('T')[0].split("-").map(v=>+v); 
    return ({ day, month,  year}) 
};
const maxDayOfMonth = (month, year) => new Date(year, month, 0).getDate();
const toISODate = (obj)=> new Date( `${obj.year}-${obj.month}-${obj.day} 12:00` ).toISOString();
const checkValidDateISOString = (isotxt)=>{ const objDate = new Date(isotxt); return !isNaN(objDate.valueOf())};


function DateSplit({ id = new Date().getTime(), date, setDate, yearFrom, yearTo, error, label, }){

    const yearsArr = setRange(yearFrom, yearTo);
    const [dayRange, setDayRange] = useState(setRange(1,31));
    const [curDate, setCurDate] = useState(toObjDate(date));

    const updDate = (val, type)=>{
        switch (type){
            case 'day':
                return setCurDate(Object.assign({}, curDate, { day: val}));
            case 'month':
                const newDayRange = maxDayOfMonth(val, curDate.year);
                const day = newDayRange < curDate.day ? 1 : curDate.day; 
                setDayRange( setRange(1,  newDayRange));
                return setCurDate( Object.assign({}, curDate, { month: val, day}) );
            case 'year':
                const newDayRange_y = maxDayOfMonth(curDate.month ,val);
                const day_y = newDayRange_y < curDate.day ? 1 : curDate.day; 
                setDayRange( setRange(1, newDayRange_y));
                return setCurDate( Object.assign({}, curDate, { year: val, day: day_y}) );
        }
    };

    const onChangeMonth = (e) => updDate(+e.target.value, "month");
    const onChangeYear = (e) => updDate(+e.target.value, "year");
    const onChangeDay = (e) => updDate(+e.target.value, "day");

    useEffect(()=>{
       const ISODate = toISODate(curDate);
       if(checkValidDateISOString(ISODate)) setDate(ISODate);
      
    }, [curDate]);


    return(
             <div className="form-row-plain">
            <div className="form-group">
            <label className="form-label">{label}</label>
            <div className="date-inline">
                <select
                className={`form-control day ${error? 'is-invalid' : ''}`}
                placeholder="День"
                id={id + 'day'}
                value={curDate.day}
                onChange={onChangeDay}
                >
                    {dayRange.map((v)=><option value={v}>{v}</option>)}
                </select>
                <select
                className={`form-select month ${error ? 'is-invalid' : ''}`}
                value={curDate.month}
                id={id + 'month'}
                onChange={onChangeMonth}
                >
                    { monthArr.map((v,i)=><option value={i+1}>{v}</option>)}
                </select>
                <select
                className={`form-control year ${error ? 'is-invalid' : ''}`}
                placeholder="Рік"
                value={curDate.year}
                id={id + 'year'}
                onChange={onChangeYear}
                >
                    { yearsArr.map((v)=><option value={v}>{v}</option>)}
                </select>
            </div>
            {error && <div className="invalid-feedback">{error}</div>}
            </div>
      </div>
    )
};

export default DateSplit;